import {
    ClaimEditor,
    ClaimEditorStore,
    clearClaimEditorReturnToMessaging,
    consumeClaimEditorReturnToMessaging,
    isClaimEditorOpenedFromMessaging,
} from '@enter/core';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { IInjectedRootStore } from 'stores';

interface IProviderClaimEditorProps extends IInjectedRootStore {}

export const ProviderClaimEditor: React.FunctionComponent<IProviderClaimEditorProps> = inject('rootStore')(
    observer((props: IProviderClaimEditorProps) => {
        const { claimId } = useParams<{ claimId: string }>();
        const navigate = useNavigate();
        const location = useLocation();
        const { rootStore } = props;

        // Check if template query parameter is present
        const searchParams = new URLSearchParams(location.search);
        const isTemplate = searchParams.get('template') === 'true';
        const fromMessaging = isClaimEditorOpenedFromMessaging(location.search);

        if (!rootStore) {
            return null;
        }

        const handleSuccess = (newClaimId: string) => {
            // Only clear when this tab opened from messaging — localStorage is shared across tabs.
            if (fromMessaging) {
                clearClaimEditorReturnToMessaging();
            }
            // Provider-specific navigation after successful submission
            navigate(`/claims/${newClaimId}`);
        };

        const handleCancel = () => {
            if (fromMessaging) {
                const returnTo = consumeClaimEditorReturnToMessaging();
                if (returnTo?.path) {
                    navigate(returnTo.path);
                    return;
                }
            }
            navigate(-1);
        };

        return (
            <ClaimEditor
                claimEditorStore={rootStore.claimEditorStore}
                claimId={claimId}
                isTemplate={isTemplate}
                onSuccess={handleSuccess}
                onCancel={handleCancel}
            />
        );
    }),
);
